import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { formatDate } from "../../Helpers/Formatters";

const PaginatedItems = ({
  itemsPerPage,
  lista,
  style,
  totalLista,
  itemOffset,
  setItemOffset,
}) => {
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    setPageCount(Math.ceil(totalLista / itemsPerPage));
  }, [itemOffset, itemsPerPage, totalLista]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % totalLista;
    setItemOffset(newOffset);
  };

  return (
    <React.Fragment>
      <div className="container-lista">
        <table>
          <thead>
            <tr className="table-tr-legenda">
              <th>Protocolo</th>
              <th>
                Início da interrupção <br /> Fim da interrupção
              </th>
              <th>
                Município <br /> UF
              </th>
              <th>Serviços afetados</th>
              <th>Causa da interrupção</th>
              <th>Solução aplicada</th>
            </tr>
          </thead>
          <tbody>
            {lista.length > 0 &&
              lista.map((item, index) => (
                <tr className="solucao" key={index}>
                  <td>{item.protocolo}</td>
                  <td>
                    {formatDate(item.data_hora_inicio)} <br />{" "}
                    {formatDate(item.data_hora_final)}
                  </td>
                  <td>
                    {item.municipio} <br /> {item.uf}
                  </td>
                  <td>{item.servicos_afetados}</td>
                  <td>{item.causa_interrupcao}</td>
                  <td>{item.solucao_aplicada}</td>
                </tr>
              ))}
            {lista.length === 0 && (
              <tr className="solucao" key={1}>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  Nenhum alerta encontrado para o filtro aplicado!
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {lista.length > 0 && (
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          className={style}
          renderOnZeroPageCount={null}
        />
      )}
    </React.Fragment>
  );
};

export default PaginatedItems;
